import request from '@/utils/request'

export function uploadImage(data) {
  return request({
    url: 'uploadFile/uploadFile',
    method: 'post',
    data
  })
}

